import { createAction, props } from '@ngrx/store';

export const disconnectGoogleAccount = createAction('[GoogleAccount] Disconnect', props<{ disconnectUrl: string }>());

export const disconnectGoogleAccountSuccess = createAction('[GoogleAccount] Disconnect Success');

export const disconnectGoogleAccountFailure = createAction('[GoogleAccount] Disconnect Failure');
